import { Routes, Route, Navigate } from 'react-router-dom'; 
import "./i18n";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import RTLLayout from "layouts/RTL.js";
import LandingLayout from "layouts/Landing";
import GOTTPanel, { GOTTPanelConfig } from "./layouts/GOTTPanel";
import theme from './theme/theme';
import themeGray from 'theme/themeGray';
import {
  ChakraProvider,
} from '@chakra-ui/react';
import { AuthProvider } from 'contexts/AuthContext';
import RouteGuard from "./guards/AuthGuard";
import { PROFILES } from "./constants/permission";
import { ToastProvider } from "./components/CustomToast/CustomToast";
import { ROUTES } from 'constants/routes-path';
import DocumentPrintBatchPage, {
  PrintProcessFinalDecision,
  PrintProcessLetter
} from "./views/Pages/Permittees/PrintDocumentInBatch/DocumentPrintBatchPage";
import DocumentPrintBatchDownloadPdfPage
  from "./views/Pages/Permittees/PrintDocumentInBatch/DocumentPrintBatchDownloadPdfPage";
import TrafficViolationTimelinePrintPage from 'views/Pages/TrafficViolation/TrafficViolationTimelinePrintPage';
import PermitteesDocumentsValidate from 'views/Pages/Permittees/Documents/PermitteesDocumentsValidate';
import { REACT_APP_USE_GRAY_THEME } from 'constants/config';
import { ProcessPrintCaPage } from 'views/Pages/Processes/ProcessPrintCaPage';
import  ChangePasswordPage  from 'views/Pages/Users/ChangePasswordPage';
// Chakra imports

export default function Main() { 
  return (
    <ChakraProvider theme={REACT_APP_USE_GRAY_THEME ? themeGray : theme}>
      <ToastProvider>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Navigate to={ROUTES.login} replace />} />
          <Route path="landing/*" element={<LandingLayout />} />
          <Route path="auth/*" element={<AuthLayout />} />
          <Route
            path={ROUTES.permitteePrintDocumentBatchPdf}
            element={<DocumentPrintBatchDownloadPdfPage />}
          />
          <Route
            path={ROUTES.permitteeValidateLicensePath}
            element={<PermitteesDocumentsValidate />}
          />
          <Route
            path={ROUTES.permitteePrintDocument}
            element={<DocumentPrintBatchPage />}
          />
          <Route
            path={ROUTES.processLetterPdf}
            element={<PrintProcessLetter />}
          />
          <Route
            path={ROUTES.processPrintFinalDecision}
            element={<PrintProcessFinalDecision />}
          />
          <Route
            path={ROUTES.trafficViolationsDetailsTimelinePrintPath}
            element={<TrafficViolationTimelinePrintPage />}
          />
          <Route
            path={ROUTES.processPrintCaPath}
            element={<ProcessPrintCaPage />}
          />
          <Route
            path={ROUTES.alterarSenha}
            element={<ChangePasswordPage />}
          />
          <Route element={<RouteGuard allowedRoles={[PROFILES.adm, PROFILES.agent]} />}>
            <Route path={GOTTPanelConfig.matcher} element={<GOTTPanel />} />

            <Route path="admin/*" element={<AdminLayout />} />

            <Route path="rtl/*" element={<RTLLayout  />} />
          </Route>
        </Routes>
      </AuthProvider>
      </ToastProvider>
    </ChakraProvider>
  );
}
